export default __webpack_public_path__ + "static/media/logo.c3b923da.png";